import { Outlet } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import DashboardFooter from '../components/dashboard/DashboardFooter';

const AuthLayout = () => {
    return (
        <Box
            sx={{
                minHeight: '100dvh',
                display: 'flex',
                flexDirection: 'column',
                bgcolor: '#FFFFFF',
                overflowX: 'hidden',
                position: 'relative'
            }}
        >
            <Box
                aria-hidden
                sx={{
                    position: 'absolute',
                    inset: 0,
                    pointerEvents: 'none',
                    background: 'linear-gradient(180deg, #FFFFFF 0%, #FCFCFC 100%)'
                }}
            />
            <Box
                aria-hidden
                sx={{
                    position: 'absolute',
                    right: { xs: 18, md: 42 },
                    bottom: { xs: 168, md: 190 },
                    width: { xs: 72, md: 110 },
                    height: { xs: 96, md: 138 },
                    opacity: 0.45,
                    backgroundImage:
                        'radial-gradient(circle, rgba(61,61,61,0.18) 1.4px, transparent 1.6px)',
                    backgroundSize: '16px 16px',
                    pointerEvents: 'none'
                }}
            />
            <Box
                sx={{
                    flex: 1,
                    minHeight: 0,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: { xs: 1.5, md: 2 },
                    py: { xs: 1.25, md: 1 },
                    position: 'relative',
                    zIndex: 1
                }}
            >
                <Outlet />
            </Box>
            <Box sx={{ width: '100%', px: 0, pb: 0, flexShrink: 0, position: 'relative', zIndex: 1 }}>
                <DashboardFooter compact authMode backgroundColor="#FFFFFF" />
                <Box
                    sx={{
                        borderTop: '1px solid #ECECEC',
                        bgcolor: '#FFFFFF',
                        py: { xs: 1.1, md: 1.35 }
                    }}
                >
                    <Typography
                        variant="body2"
                        textAlign="center"
                        sx={{
                            color: '#7C8594',
                            fontSize: { xs: '0.78rem', md: '0.92rem' }
                        }}
                    >
                        © 2026 INFO.CUIDADOR 2.0. Todos os direitos reservados.
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default AuthLayout;
